import { minPatchEditPermissionsDto } from '@adflow/shared/util-data';
import { makeRecord, objectKeys } from '@adflow/shared/util-js';
import {
	minPatchObject,
	minPatchPrimitive,
} from '@adflow/shared/util-superstruct';

import { EditRoleDto } from './edit-role.dto';

export const minPatchEditRoleDto = minPatchObject<EditRoleDto>({
	...makeRecord(objectKeys(EditRoleDto.schema), () => minPatchPrimitive),

	permissions: minPatchEditPermissionsDto,
});
